import React from 'react';
import { Card, Row, Col, Button } from 'react-bootstrap';
import data from '../mockdata/settingMenu.json';
import currencyData from '../mockdata/currencyList.json';
import '../stylesheets/Home.css';
import { SettingContext } from '../context/SettingContext';
import SettingUpdateDialogue from './SettingUpdateDialogue';

const langdata = data.map((data) => {
    return (
        <option key={data.id} value={data.language}>{data.language}</option>
    );
});

const currencydata = currencyData.map((currencyData) => {
    return (
        <option key={currencyData.id} value={currencyData.currency}>{currencyData.currency}</option>
    );
});

class Settings extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedLang: localStorage.language ? localStorage.getItem('language') : data[0].language,
            selectedCurrency: localStorage.currency ? localStorage.getItem('currency') : currencyData[0].currency
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
    }
    static contextType = SettingContext

    handleChange(event) {
        this.setState({ selectedLang: event.target.value });
    }
    handleCurrencyChange(event) {
        this.setState({ selectedCurrency: event.target.value });
    }


    render() {

        const { toggleSetting, closeDialogue, showDialogue } = this.context;
        return (
            <>
                {showDialogue ?
                    <SettingUpdateDialogue show={showDialogue} language={this.state.selectedLang} currency={this.state.selectedCurrency} closeDialogue={closeDialogue} />
                    : null}
                <Row className="mt-5">
                    <Col md={{ span: 6, offset: 3 }}>
                        <Card className="text-center">
                            <Card.Body>
                                <Row>
                                    <Col md="12" lg="6">
                                        <Card.Title className={'selectTerminal-margin'}>Select Language</Card.Title>
                                    </Col>
                                    <Col md="12" lg="6">
                                        <select className="custom-select" id="languageSelect" value={this.state.selectedLang} selected={this.state.selectedLang} onChange={this.handleChange}>
                                            {langdata}
                                        </select>
                                    </Col>
                                    <Col md="12" lg="6">
                                        <Card.Title className={'selectTerminal-margin'}>Select Currency</Card.Title>
                                    </Col>
                                    <Col md="12" lg="6">
                                        <select className="custom-select" id="currencySelect" value={this.state.selectedCurrency} selected={this.state.currency} onChange={this.handleCurrencyChange}>
                                            {currencydata}
                                        </select>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row className="mt-5">
                    <Col md={{ span: 4, offset: 4 }}>
                        <div className="text-center">
                            <Button variant="primary" size="lg" id="saveSetting" onClick={() => { toggleSetting(this.state.selectedLang, this.state.selectedCurrency); }} block>
                                Save
                            </Button>
                        </div>
                    </Col>
                </Row>
            </>
        );
    }
}

export default Settings;